import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { get2 } from "../axios";
import { Menu } from "../utils/interfaces";
import useBranchId from "./useBranchId";
import useLocationHook from "./useLocationHook";
import useStandardMenuTargetHook from "./useStandardMenuTargetHook";
import { isFavoriteCategory } from "../utils/helpers";
const useCategoryQueryHook = () => {
  const language = 0;
  const branch = useBranchId();
  const { isPosOrderPage, isLivePage, isWaiterPage } = useLocationHook();
  const { standardMenuTarget } = useStandardMenuTargetHook();
  const posMenuUrl = `external/anonymous/websites/v3/menus/complete/${branch}/${standardMenuTarget}/${language}`;
  const menuUrl = `/internal/secure/pos/v2/menus/complete/${branch}`;
  const url =
    isPosOrderPage || isLivePage || isWaiterPage ? posMenuUrl : menuUrl;

  const queryKey = ["cat", branch, url];

  const query = useQuery<Menu>({
    queryKey: queryKey,
    queryFn: () => get2(url),
    enabled: false,
    refetchOnWindowFocus: false,
    select: (menu) => {
      return {
        ...menu,
        navigation_content: menu.navigation_content.map((category) => {
          const isFavorite = isFavoriteCategory(category.virtual_item_type);
          if (!isFavorite) return category;
          return {
            ...category,
            sub_content: category.sub_content?.map((product) => ({
              ...product,
              parent_id:
                product.original_category_id ??
                menu.original_category_ids?.[product.item_id],
            })),
          };
        }),
      };
    },
  });
  const categories = useMemo(() => {
    return query.data ? query.data.navigation_content : [];
  }, [query.data]);
  const products = useMemo(
    () =>
      categories
        .filter((category) => !isFavoriteCategory(category.virtual_item_type))
        .flatMap((category) =>
          (category.sub_content ?? []).map((product) => ({
            ...product,
            parent_id: category.item_id,
            parent_name: category.name,
          }))
        ),
    [categories]
  );
  return {
    ...query,
    queryKey,
    categories,
    products,
  };
};
export default useCategoryQueryHook;
